/*
  Stock Archi – Pastilles de couleur
  Couleurs : métachamp de variante custom.couleur_pastille (attribut data-sa-color des <option>).

  A. Produits sans groupes de couleur :
     1. pastille ronde à gauche de la liste déroulante, qui suit la couleur choisie ;
     2. nuancier sous la quantité et le bouton d'ajout au panier si la case
        « Afficher le nuancier » est cochée sur la fiche produit.
  B. Produits avec groupes (métachamp de variante custom.famille_couleur renseigné) :
     « Groupe de couleur » (liste) à gauche, « Nuance de couleur » (pastilles du groupe) à droite.
     La liste d'origine du thème est cachée mais reste la référence pour le panier.
*/
(function () {
  'use strict';

  var ALL = '__all__';

  function scopeOf(el) {
    return el.closest('[data-section-id], .shopify-section, section') || document;
  }

  function familyOf(opt) { return opt ? (opt.getAttribute('data-sa-family') || '') : ''; }

  // Toutes les listes du thème pour cette option (le thème peut en créer une copie)
  function nativesOf(ctx) {
    return Array.prototype.filter.call(ctx.option.querySelectorAll('select'), function (s) {
      return s !== ctx.famSel && s.querySelector('option[data-sa-color]');
    });
  }

  function nativeOf(ctx) { return nativesOf(ctx)[0] || null; }

  function bindNative(ctx) {
    nativesOf(ctx).forEach(function (s) {
      if (s._saBound) return;
      s._saBound = true;
      s.addEventListener('change', function () { if (!ctx.choosing) refresh(ctx); });
    });
  }

  function choose(ctx, index) {
    var s = nativeOf(ctx);
    if (!s || !s.options[index] || s.options[index].disabled) return;
    var value = s.options[index].value;
    ctx.choosing = true;
    nativesOf(ctx).forEach(function (n) {
      if (n.value === value) return;
      n.value = value;
      n.dispatchEvent(new Event('input', { bubbles: true }));
      n.dispatchEvent(new Event('change', { bubbles: true }));
    });
    ctx.choosing = false;
    refresh(ctx);
  }

  /* ---------- Grille de pastilles (nuancier) ---------- */

  function buildGrid(ctx, s, nameEl) {
    var grid = document.createElement('div');
    grid.className = 'sa-chart__grid';
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', 'Nuancier');
    if (!ctx.groups && s.options.length > 60) grid.classList.add('sa-chart__grid--compact');

    Array.prototype.forEach.call(s.options, function (opt, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sa-chart__swatch';
      var label = opt.textContent.trim();
      var color = opt.getAttribute('data-sa-color');
      if (color) b.style.backgroundColor = color; else b.classList.add('sa-chart__swatch--empty');
      b.title = label;
      b.setAttribute('aria-label', label);
      b.setAttribute('role', 'radio');
      b.setAttribute('data-index', i);
      b.setAttribute('data-family', familyOf(opt));
      grid.appendChild(b);
    });

    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.sa-chart__swatch');
      if (b) choose(ctx, parseInt(b.getAttribute('data-index'), 10));
    });
    grid.addEventListener('mouseover', function (e) {
      var b = e.target.closest('.sa-chart__swatch');
      if (b) { ctx.hovering = true; nameEl.textContent = b.title; }
    });
    grid.addEventListener('mouseleave', function () { ctx.hovering = false; refresh(ctx); });
    grid.addEventListener('keydown', function (e) {
      var btns = Array.prototype.filter.call(grid.children, function (x) { return !x.classList.contains('is-filtered'); });
      var i = btns.indexOf(document.activeElement);
      if (i < 0) return;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = btns[i + 1];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = btns[i - 1];
      if (next) { e.preventDefault(); next.focus(); choose(ctx, parseInt(next.getAttribute('data-index'), 10)); }
    });

    ctx.grid = grid;
    ctx.nameEl = nameEl;
    return grid;
  }

  function updateGrid(ctx, s) {
    if (!ctx.grid) return;
    var fam = ctx.famSel ? ctx.famSel.value : ALL;
    Array.prototype.forEach.call(ctx.grid.children, function (b) {
      var i = parseInt(b.getAttribute('data-index'), 10);
      var opt = s.options[i];
      var sel = i === s.selectedIndex;
      b.classList.toggle('is-selected', sel);
      b.setAttribute('aria-checked', sel ? 'true' : 'false');
      b.tabIndex = sel ? 0 : -1;
      b.classList.toggle('is-disabled', !!(opt && opt.disabled));
      b.classList.toggle('is-filtered', fam !== ALL && b.getAttribute('data-family') !== fam);
    });
    if (!ctx.hovering) {
      var cur = s.options[s.selectedIndex];
      ctx.nameEl.textContent = cur ? cur.textContent.trim() : '';
    }
  }

  /* ---------- A. Pastille + nuancier sous le bouton panier ---------- */

  function buildSimple(ctx, s) {
    var dot = document.createElement('span');
    dot.className = 'sa-dot';
    dot.setAttribute('aria-hidden', 'true');
    ctx.host.classList.add('sa-dot-host');
    ctx.host.insertBefore(dot, ctx.host.firstChild);
    ctx.option.classList.add('sa-dot-option');
    ctx.dot = dot;

    if (!ctx.option.closest('[data-sa-chart]')) return;
    var scope = scopeOf(ctx.option);
    var anchor = scope.querySelector('.quantity-button-ctn') ||
                 scope.querySelector('.product-form__controls-group--submit') ||
                 scope.querySelector('form[data-product-form]');
    if (!anchor) return;

    var chart = document.createElement('div');
    chart.className = 'sa-chart product__block product__block--medium';
    var head = document.createElement('div');
    head.className = 'sa-chart__head fs-body-75';
    var title = document.createElement('span');
    title.className = 'sa-chart__title';
    title.textContent = 'Nuancier';
    var name = document.createElement('span');
    name.className = 'sa-chart__name';
    head.appendChild(title);
    head.appendChild(name);
    chart.appendChild(head);
    chart.appendChild(buildGrid(ctx, s, name));
    anchor.parentNode.insertBefore(chart, anchor.nextSibling);
  }

  function updateDot(ctx, s) {
    if (!ctx.dot) return;
    var opt = s.options[s.selectedIndex];
    var color = opt && opt.getAttribute('data-sa-color');
    ctx.dot.style.backgroundColor = color || '';
    ctx.dot.classList.toggle('sa-dot--empty', !color);
    ctx.dot.title = opt ? opt.textContent.trim() : '';
  }

  /* ---------- B. Groupe de couleur + pastilles de nuance ---------- */

  function buildGroups(ctx, s, fams) {
    ctx.groups = true;
    var uid = s.id || ('sa' + Math.random().toString(36).slice(2, 8));

    var famSel = document.createElement('select');
    famSel.className = 'input sa-fam-select';
    famSel.id = 'sa-fam-' + uid;
    var all = document.createElement('option');
    all.value = ALL;
    all.textContent = 'Toutes les couleurs';
    famSel.appendChild(all);
    fams.forEach(function (f) {
      var o = document.createElement('option');
      o.value = f;
      o.textContent = f;
      famSel.appendChild(o);
    });
    ctx.famSel = famSel;

    var row = document.createElement('div');
    row.className = 'sa-fam-row';

    var colA = document.createElement('div');
    colA.className = 'sa-fam-col';
    var labA = document.createElement('label');
    labA.className = 'product__label fs-body-100 sa-fam-label';
    labA.setAttribute('for', famSel.id);
    labA.textContent = 'Groupe de couleur';
    colA.appendChild(labA);
    colA.appendChild(famSel);

    var colB = document.createElement('div');
    colB.className = 'sa-fam-col';
    // Au-dessus des pastilles : uniquement le nom de la teinte, sur une seule ligne
    var labB = document.createElement('div');
    labB.className = 'product__label fs-body-100 sa-fam-label sa-fam-label--name';
    var name = document.createElement('span');
    name.className = 'sa-fam-name';
    labB.appendChild(name);
    colB.appendChild(labB);
    colB.appendChild(buildGrid(ctx, s, name));

    row.appendChild(colA);
    row.appendChild(colB);
    ctx.option.insertBefore(row, ctx.option.firstChild);
    ctx.option.classList.add('sa-fam-option');

    famSel.value = familyOf(s.options[s.selectedIndex]) || ALL;
    famSel.addEventListener('change', function () {
      var cur = nativeOf(ctx);
      if (!cur) return;
      if (famSel.value !== ALL && familyOf(cur.options[cur.selectedIndex]) !== famSel.value) {
        for (var i = 0; i < cur.options.length; i++) {
          if (familyOf(cur.options[i]) === famSel.value && !cur.options[i].disabled) { choose(ctx, i); return; }
        }
      }
      refresh(ctx);
    });
  }

  // La liste du thème (et tout ce qu'il ajoute autour) reste dans la page mais invisible
  function hideThemeList(ctx) {
    if (!ctx.groups) return;
    Array.prototype.forEach.call(ctx.option.children, function (el) {
      if (el.classList.contains('sa-fam-row')) return;
      el.style.setProperty('display', 'none', 'important');
    });
    nativesOf(ctx).forEach(function (s) { s.tabIndex = -1; });
  }

  /* ---------- Mise à jour ---------- */

  function refresh(ctx) {
    var s = nativeOf(ctx);
    if (!s) return;
    ctx.busy = true;
    bindNative(ctx);
    hideThemeList(ctx);
    updateDot(ctx, s);
    if (ctx.famSel) {
      var curFam = familyOf(s.options[s.selectedIndex]);
      if (ctx.famSel.value !== ALL && curFam && ctx.famSel.value !== curFam) ctx.famSel.value = curFam;
    }
    updateGrid(ctx, s);
    setTimeout(function () { ctx.busy = false; }, 0);
  }

  function enhance(s) {
    var option = s.closest('.product__option') || s.parentNode;
    if (option._saCtx) { refresh(option._saCtx); return; }
    if (!s.querySelector('option[data-sa-color]')) return;

    var ctx = { option: option, host: s.parentNode };
    option._saCtx = ctx;

    var fams = [];
    Array.prototype.forEach.call(s.options, function (opt) {
      var f = familyOf(opt);
      if (f && fams.indexOf(f) < 0) fams.push(f);
    });

    if (fams.length > 1) buildGroups(ctx, s, fams);
    else buildSimple(ctx, s);
    refresh(ctx);

    // Le thème peut remplacer ou réafficher sa liste : on la recache et on se resynchronise
    new MutationObserver(function (records) {
      if (ctx.busy) return;
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (ctx.grid && (t === ctx.grid || ctx.grid.contains(t))) continue;
        if (ctx.famSel && t === ctx.famSel) continue;
        refresh(ctx);
        return;
      }
    }).observe(option, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  function init() {
    document.querySelectorAll('.product__variants-wrapper select[name^="options["]').forEach(enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);

  document.addEventListener('change', function () { setTimeout(init, 50); }, true);
  var lastUrl = location.href;
  setInterval(function () {
    if (location.href !== lastUrl) { lastUrl = location.href; init(); }
  }, 300);
})();
